import React, { useEffect, useState, Fragment } from "react";
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing";
import "./Header.scss";
import { GA_Push } from "../Services/GoogleAnalytics";

const sections = ["backtoschool", "sandwich", "springroll", "kassadia", "kosmin", "omlet", "pita", "videosbottom"];

const Header = (props) => {

  const { setTransform, currentScreen } = props;
  const [isShareActive, setIsShareActive] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const circles = ['עמוד בית', 'כריך ים תיכוני', "כריך ספרינג רול", "קאסדייה", "כריך לחם כוסמין", "כריך חביתה מיוחדת", "כריך פיצה חם", "קופצים כיתה עם נֹעם"];

  const activateSharer = () => {
    setIsShareActive(!isShareActive);
  }

  useEffect(() => {
    setIsMenuOpen(
      window.innerWidth > 800 ? true : false
    );
  }, []);

  return (
    <header>
      <div id="header">

        <div className="padding">

          <div className={`menu-container ${isMenuOpen ? "active" : ""}`} >
            {isMenuOpen ? <Fragment>
              <div className="circle-container">
                {circles.map((circle, index) =>
                  <React.Fragment key={index}>
                    <div className="line"></div>
                    <div key={index} className="circle" onClick={() => {

                      GA_Push("Navigation_Events", sections[index], "Navigation_Events");
                      setTransform(index)
                    }}>
                      <div className="circle-text">{circle}</div>
                      <div className={`circle-bg circle-${index + 1} ${currentScreen === index ? "active" : ""}`}></div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </Fragment> : <div className="menu-line-container" onMouseEnter={() => setIsMenuOpen(true)}>
                <div className="menu-navigation-line">
                  {circles.map((_, index) => <div key={index} className={`menu-navigation-circle ${currentScreen == index ? "active" : ""}`}></div>)}
                </div>
              </div>}

          </div>


          <div className="container">
            <div className="company-logos">
              <a target="_blank" href="http://www.tara.co.il">
                <div className="tara-logo"></div>
              </a>
              <div className="line-seperator"></div>
              <a target="_blank" href="https://www.ynet.co.il?utm_source=http://source-qa-a.ynet.co.il/short/commerce/backtoschool/&utm_medium=referral&utm_campaign=tara backtoschool">
                <div className="ynet-logo"></div>
              </a>
            </div>

            <div className={`social-media ${isMenuOpen ? "active" : ""}`}>
              <div onClick={shareWhatsapp} className="whatsapp"></div>
              <div onClick={shareFacebook} className="facebook"></div>
              <div onClick={openNegishut} className="ngishot"></div>
            </div>
            <div onClick={() => { setIsMenuOpen(!isMenuOpen) }} className={`hamburger-nav ${isMenuOpen ? "active" : ""}`}>
              <div className="line" />
              <div className="line" />
              <div className="line" />
            </div>
          </div>

        </div>

      </div>
      <div id="virtualHeader"></div>
    </header>
  );
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx